module.exports = __webpack_public_path__ + "static/media/moveShiftHere.e8bfaee3.svg";